/**
 * Issue #270 — 录音文件转写 provider 配置状态判定（纯函数，便于单测）。
 *
 * Codex 生产审计：长音频上传卡 59% 的根因之一是**没有配置任何录音文件转写凭据**——
 * 录音文件链（xfyun_file_ws_llm / 标准版 / 极速 OST）全部 isConfigured=false 时，
 * 最终转写会退化到实时 IAT 的 <=60s 切片推流（慢、长录音易卡）。管理后台需要把这一
 * 根因显著提示给管理员，并指引去配置缺失的凭据（env 名由各 provider 的 configHint 给出）。
 */

export interface AsrProviderConfigStatus {
  id: string;
  configured: boolean;
  /** 各 provider 的脱敏配置提示（env 变量**名**，绝无密钥值）。 */
  configHint: string;
}

/**
 * 是否「有录音文件 provider，但没有任何一个已配置」——此时长音频退化到实时 IAT 切片。
 * 没有任何录音文件 provider（异常/空数据）时返回 false（交由整体「服务不可用」提示处理）。
 */
export function noRecordingFileProviderConfigured(
  providers: ReadonlyArray<{ configured: boolean }>,
): boolean {
  return providers.length > 0 && providers.every((p) => !p.configured);
}

/**
 * 未配置的录音文件 provider 的脱敏提示列表（用于警告横幅指引），去重保序。
 * 仅返回 env 变量名提示，绝不含任何密钥值。
 */
export function missingRecordingFileCredHints(
  providers: ReadonlyArray<AsrProviderConfigStatus>,
): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const p of providers) {
    if (p.configured) continue;
    const hint = p.configHint?.trim();
    if (!hint || seen.has(hint)) continue;
    seen.add(hint);
    out.push(hint);
  }
  return out;
}
